<template>
  <div class="content_two">
      <div class="pet_box">
          <img src="../assets/images/close.png" class="close" alt="" @click="gohome">
          <div class="label1" @click="active_show(1)">
              <div v-if="active==1" class="selected">主要伙伴</div>
              <div v-else class="unselected"  @click="getPet(1)">主要伙伴</div>
          </div>
          <div class="label2" @click="active_show(2)">
              <div v-if="active==2" class="selected">备用伙伴</div>
              <div v-else class="unselected"  @click="getPet(2)">备用伙伴</div>
          </div>
          <div class="left">
              <div class="chat">
                  <div class="title">{{petInfo.desc}}</div>
                  <!-- <div class="chat_content">
                        碧玉妆成一树高，万条垂下绿丝绦。
                        不知细叶谁裁出，二月春风似剪刀。
                        碧玉妆成一树高，万条垂下绿丝绦。
                        不知细叶谁裁出，二月春风似剪刀。 
                  </div> -->
              </div>
              <div class="totem">
                  <!-- <div ></div> -->
                  <div v-if="growth_stage=='y'&&petInfo.level">
                            <img v-if="showgif==0" :src="petInfo.level[0].pet_image_url" alt="" class="pet_bgc" >
                            <img v-if="petInfo.level[0].img01 && showgif==1" :src="petInfo.level[0].img01" class="pet_bgc" alt="">
                            <img v-if="petInfo.level[0].img02 && showgif==2" :src="petInfo.level[0].img02" class="pet_bgc" alt="">
                            <img v-if="petInfo.level[0].img03 && showgif==3" :src="petInfo.level[0].img03" class="pet_bgc" alt="">
                            <img v-if="petInfo.level[0].img04 && showgif==4" :src="petInfo.level[0].img04" class="pet_bgc" alt="">
                  </div>
                  <div v-if="growth_stage=='s'&&petInfo.level">
                            <img v-if="showgif==0" :src="petInfo.level[1].pet_image_url" alt="" class="pet_bgc" >
                            <img v-if="petInfo.level[1].img01 && showgif==1" :src="petInfo.level[1].img01" class="pet_bgc" alt="">
                            <img v-if="petInfo.level[1].img02 && showgif==2" :src="petInfo.level[1].img02" class="pet_bgc" alt="">
                            <img v-if="petInfo.level[1].img03 && showgif==3" :src="petInfo.level[1].img03" class="pet_bgc" alt="">
                            <img v-if="petInfo.level[1].img04 && showgif==4" :src="petInfo.level[1].img04" class="pet_bgc" alt="">
                  </div>
                  <div v-if="growth_stage=='c'&&petInfo.level">
                            <img v-if="showgif==0" :src="petInfo.level[2].pet_image_url" alt="" class="pet_bgc" >
                            <img v-if="petInfo.level[2].img01 && showgif==1" :src="petInfo.level[2].img01" class="pet_bgc" alt="">
                            <img v-if="petInfo.level[2].img02 && showgif==2" :src="petInfo.level[2].img02" class="pet_bgc" alt="">
                            <img v-if="petInfo.level[2].img03 && showgif==3" :src="petInfo.level[2].img03" class="pet_bgc" alt="">
                            <img v-if="petInfo.level[2].img04 && showgif==4" :src="petInfo.level[2].img04" class="pet_bgc" alt="">
                  </div>
                   <!-- <div v-for="(item,index) in petInfo.level" :key="index" v-if="item.levels==petInfo.pet_level">
                      <img v-if="show_motion==0" :src="item.pet_image_url" alt="" class="pet_bgc" >
                      <div v-else>
                            <img v-if="item.img01 && showgif==1" :src="item.img01" class="pet_bgc" alt="">
                            <img v-if="item.img02 && showgif==2" :src="item.img02" class="pet_bgc" alt="">
                            <img v-if="item.img03 && showgif==3" :src="item.img03" class="pet_bgc" alt="">
                            <img v-if="item.img04 && showgif==4" :src="item.img04" class="pet_bgc" alt="">
                      </div>
                  </div> -->
                  <div class="magic_circle"></div>
              </div>
              <div class="exp_box">
                  <!-- <img src="../assets/images/exp.png" class="exp" alt=""> -->
                  <div class="progress_bar">
                      <div class="progress_val">
                          <div class="progress" :style="{width: per+'%'}"></div>
                          <span class="pet_exp">{{petInfo.empirical}}/{{petInfo.next_level_empirical}}</span>
                      </div>
                  </div>
              </div>
              <div class="growth_stage">
                  <div>
                      <div v-if="petInfo.pet_level=='幼年'|| petInfo.pet_level=='少年'||petInfo.pet_level=='成年'" class="purple" @click="growthStage('y')"> <span>幼<br/>年</span></div>
                      <div v-else class="gray"><span>幼<br/>年</span></div>
                  </div>
                   <div>
                       <div v-if="petInfo.pet_level=='少年'||petInfo.pet_level=='成年'" class="purple" @click="growthStage('s')"><span>少<br/>年</span></div>
                       <div v-else class="gray"><span>少<br/>年</span></div>
                  </div>
                  <div>
                      <div v-if="petInfo.pet_level=='成年'" class="purple" @click="growthStage('c')"><span>成<br/>年</span></div>
                      <div v-else class="gray"><span>成<br/>年</span></div>
                  </div>
              </div>
              <img v-if="active==2 && petInfo" src="../assets/images/set_pet_btn.png" class="set_pet_btn" alt="" @click="setMainPet">
              <img v-if="active==2 && petInfo" src="../assets/images/motion.png" class="motion" alt="" @click="control">
              <img v-if="active==1 && petInfo" src="../assets/images/motion.png" class="motion2" alt="" @click="control">
          </div>
          <div class="right">
              <div class="name">LV.{{petInfo.pet_grade}} {{petInfo.pet_name}}</div>
              <div class="condition">
                  <div class="rarity card">
                        <div class="img">
                            <img src="../assets/images/xiyoudu.png" alt="">
                        </div>
                        <div class="yellow_text">稀有度</div>
                        <div class="black_text">{{petInfo.rarity}}</div>
                  </div>
                  <div class="character card">
                       <div class="img">
                            <img src="../assets/images/xingge.png" alt="">
                        </div>
                        <div class="yellow_text">性格</div>
                        <div class="black_text">{{petInfo.character}}</div>
                  </div>
                  <div class="grow_up card">
                       <div class="img">
                            <img src="../assets/images/chengzheng.png" alt="">
                        </div>
                        <div class="yellow_text">成长</div>
                        <div class="black_text">{{petInfo.pet_level}}</div>
                  </div>
              </div>
             <!-- 成长 -->
              <div>
                    <div class="chengzhang_label">总成长(学习 + 抗挫 + 反应)</div>
                    <div class="chengzhang_bar">
                        <div class="chengzhang_val_box" v-if="petInfo.up">
                            <div class="chengzhang_val" :style="{width: (petInfo.up.attr.avg / petInfo.up.attr.max * 100)>100? '100%': (petInfo.up.attr.avg / petInfo.up.attr.max * 100)+'%'}"></div>
                            <span class="span_value">{{petInfo.up.attr.avg}}</span>
                        </div>
                    </div>
              </div>
             <!-- 生命 -->
              <div>
                  <div class="shengming_label">体能({{petInfo.init_attr01}})</div>
                  <div class="shengming_bar">
                      <div class="shengming_val_box" v-if="petInfo.up">
                          <div class="shengming_val" :style="{width:(petInfo.up.attr01.avg / petInfo.up.attr01.max * 100)>100? '100%':(petInfo.up.attr01.avg / petInfo.up.attr01.max * 100)+'%'}"></div>
                          <span class="span_value">{{petInfo.up.attr01.avg}}</span>
                      </div>
                  </div>
              </div>
               <!-- 攻击 -->
              <div>
                  <div class="gongji_label">学习({{petInfo.init_attr02}})</div>
                  <div class="gongji_bar">
                      <div class="gongji_val_box" v-if="petInfo.up">
                          <div class="gongji_val" :style="{width: (petInfo.up.attr02.avg / petInfo.up.attr02.max * 100)>100?'100%':(petInfo.up.attr02.avg / petInfo.up.attr02.max * 100)+'%'}"></div>
                          <span class="span_value">{{petInfo.up.attr02.avg}}</span>
                      </div>
                  </div>
              </div>
              <!-- 防御 -->
              <div>
                  <div class="fangyu_label">抗挫({{petInfo.init_attr03}})</div>
                  <div class="fangyu_bar">
                      <div class="fangyu_val_box" v-if="petInfo.up">
                          <div class="fangyu_val" :style="{width: (petInfo.up.attr03.avg / petInfo.up.attr03.max * 100)>100?'100%':(petInfo.up.attr03.avg / petInfo.up.attr03.max * 100)+'%'}"></div>
                           <span class="span_value">{{petInfo.up.attr03.avg}}</span>
                      </div>
                  </div>
              </div>
               <!-- 速度 -->
              <div>
                  <div class="sudu_label">反应({{petInfo.init_attr04}})</div>
                  <div class="sudu_bar">
                      <div class="sudu_val_box" v-if="petInfo.up">
                          <div class="sudu_val" :style="{width: (petInfo.up.attr04.avg / petInfo.up.attr04.max * 100)>100?'100%':(petInfo.up.attr04.avg / petInfo.up.attr04.max * 100)+'%'}"></div>
                          <span class="span_value">{{petInfo.up.attr04.avg}}</span>
                      </div>
                  </div>
              </div>
              <!-- 升级 -->
              <img src="../assets/images/upgrade_btn.png" class="upgrade" alt="" @click="goknapsack()">
          </div>
      </div>
  </div>
</template>

<script>
export default {
    data(){
        return {
            active: 1,
            //经验值
            width: 80+'%',
            //成长值
            czwidth: 80+'%',
            //生命
            smwidth: 80+'%',
            //攻击
            gjwidth: 80+'%',
            //防御
            fywidth: 80+'%',
            //速度
            sdwidth: 80+'%',
            //宠物信息
            petInfo:'',
            //性格id
            character:'',
            //展示动图
            // show_motion:0,
            showgif:0,
            per: 0,
            //成长状态
            growth_stage:'y',
        }
    },
    created(){
        this.getPet();
    },
    methods:{
        //点击阶段
        growthStage(val){
            this.showgif=0;
            if(this.growth_stage==val) return;
            this.growth_stage=val
        },
        gohome(){
            this.$router.replace('/home')
        },
        active_show(num){
            if(this.active==num) return;
            this.active=num
        },
        //获取宠物
        getPet(is_main){
            if(!is_main) {
                is_main=1
            }
            this.$axios.get(
                '/api/v1/user/pet',
                {
                    params:{
                        is_main
                    }
                }
            ).then(res=>{
                console.log(res);
                if(res.data){
                    this.petInfo=res.data.data
                    this.per = this.petInfo.per ? this.petInfo.per : 0;
                    this.getcharacter();
                }
                
            })
        },
        //获取性格
        getcharacter(){
            this.$axios.get(
                '/api/v1/getpetcharacter',
            ).then(res=>{
                // console.log(res);
                var data=res.data.data
                data.forEach(it => {
                    if(this.petInfo.character==it.character){
                        this.character=it.id
                    }
                });
            })
        },
        //设为主伙伴
        setMainPet(){
            this.$axios.post(
                '/api/v1/user/setmain',
                {
                    pet_id: this.petInfo.pet_id,
                }
            ).then(res=>{
                if(res.data.result_code==200){
                    this.$msg.success(res.data.message)
                    this.active=1,
                    this.getPet();
                }else {
                    this.$msg.error(res.data.message)
                }
            })
        },
        //去背包
        goknapsack(){
            //宠物名
            var pet_name=this.petInfo.pet_name
            //宠物id
            var pet_id=this.petInfo.pet_id
            // this.$router.replace('/knapsack?pet_name='+pet_name+'&character='+this.character+'&pet_id='+pet_id)
            this.$router.push({ 
                path:'/knapsack',
                //params传参 需要使用 name 否则取不到；对应路由配置的 name
                name:'knapsack',
                params: {
                    pet_name: pet_name,
                    pet_id: pet_id,
                    character: this.character
                }
            })
        },
        //控制gif展示
        control(){
           
            var num=0;
            if(this.petInfo.pet_level=='幼年'){
                num=this.petInfo.level[0].image_num
            }else if(this.petInfo.pet_level=='少年'){
                 num=this.petInfo.level[1].image_num
            }else {
                num=this.petInfo.level[2].image_num
            }

            this.showgif=this.showgif+1
            if(this.showgif>=num){
                this.show_motion=0;
                this.showgif=0
            }
        }
    },
    mounted(){},
}
</script>

<style scoped>
.pet_exp {
    position: absolute;
    top: 50%;
    left: 50%;
    font-size: 0.1rem;
    font-family: 'Normal';
    transform: translate(-50%,-50%);
}
.pet_box {
    width: 7.96rem;
    height: 4.36rem;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%,-50%);
    background: url('../assets/images/pet_bgc.png') no-repeat;
    background-size: 100% 100%;
}
.close {
    width: 0.65rem;
    height: 0.65rem;
    position: absolute;
    top: 0;
    right: 0;
}
.close img {
    width: 100%;
    height: 100%;
}
.selected {
    width: 0.91rem;
    height: 0.41rem;
    background: url('../assets/images/red_label.png') no-repeat;
    background-size: 100% 100%;
    font-size: 0.17rem;
    font-family: 'Normal';
    color: #564205;
    text-align: center;
    line-height: 0.35rem;
    cursor: pointer;
}
.unselected {
    width: 0.81rem;
    height: 0.38rem;
    background: url('../assets/images/label.png') no-repeat;
    background-size: 100% 100%;
    font-size: 0.17rem;
    font-family: 'Normal';
    color: #564205;
    text-align: center;
    line-height: 0.3rem;
    cursor: pointer;
}
.label1 div {
    position: absolute;
    top: 1.49rem;
    left: 0.35rem;
}
.label2 div {
    position: absolute;
    top: 2.05rem;
    left: 0.35rem;
}
.left {
    width: 3.3rem;
    height: 80%;
    position: absolute;
    top: 0.5rem;
    left: 1.1rem;
}
.totem {
    width: 2.03rem;
    height: 2.05rem;
    /* background: url('../assets/images/totem.png') no-repeat; */
    /* background-size: 100% 100%; */
    position: absolute;
    top: 0.8rem;
    left: 0.3rem;
}
.pet_bgc {
    width: 1.77rem;
    height: 1.88rem;
    /* background: url('../assets/images/Charmander.png') no-repeat; */
    /* background-size: 100% 100%; */
    position: absolute;
    top: 0.07rem;
    left: 50%;
    transform: translate(-50%,0);
    z-index: 999;
}
/* .magic_circle {
    width: 1.9rem;
    height: 0.95rem;
    background: url('../assets/images/magic_circle.png') no-repeat;
    background-size: 100% 100%;
    position: absolute;
    top: 1.1rem;
    left: 0.1rem;
} */
.exp_box {
    /* width: 100%;
    height: 0.29rem; */
    width: 1.99rem;
    height: 0.21rem;
    position: absolute;
    bottom: 0.49rem;
    left: 0.3rem;
    /* box-sizing: border-box;
    padding-left: 0.2rem; */
}
/* .exp {
    width: 0.29rem;
    height: 0.29rem;
} */
.progress_bar {
    width: 1.99rem;
    height: 0.21rem;
    background: url('../assets/images/progress_bar1.png') no-repeat;
    background-size: 100% 100%;
    position: relative;
}
.progress_val {
    width: 97%;
    height: 70%;
    position: absolute;
    top: 50%;
    left: 0.03rem;
    transform: translate(0,-51%);
    /* border-radius: 0.07rem;
    background-image: linear-gradient(to right, #1B86E3 , #42BAEB);
    text-align: center;
    color: #fff;
    font-size: 0.01rem; */
}
.progress {
    height: 100%;
    border-radius: 0.07rem;
    background-image: linear-gradient(to right, #FE6F01 , #FFFF00);
    text-align: center;
    color: #000;
    /* font-weight: 600; */
    font-size: 0.08rem;
    font-family: 'Normal';
    line-height: 1.7;
}
.right {
    width: 3.22rem;
    height: 3.53rem;
    position: absolute;
    top: 0.42rem;
    right: 0.6rem;
    background: url('../assets/images/pet_info_bgc.png') no-repeat;
    background-size: 100% 100%;
}
.right .name {
    position: absolute;
    top: 0.47rem;
    left: 50%;
    transform: translate(-50%,0);
    font-size: 0.16rem;
    font-family: 'Medium';
    color: #482201;
    font-weight: bold;
}
.condition {
    width: 2.54rem;
    height: 0.99rem;
    background-color: #E5BD76;
    position: absolute; 
    top: 0.81rem;
    left: 50%;
    transform: translate(-50%,0);
    border-radius: 0.05rem;
}
.condition .card {
    display: inline-block;
    width: 0.68rem;
    height: 0.83rem;
    background: url('../assets/images/condition_bgc.png') no-repeat;
    background-size: 100% 100%;
}
.rarity {
    position: absolute; 
    top: 0.09rem;
    left: 0.08rem;
}
.character {
    position: absolute; 
    top: 0.09rem;
    left: 0.93rem;
}
.grow_up {
    position: absolute; 
    top: 0.09rem;
    right: 0.08rem;
}
.rarity .img {
    width: 0.22rem;
    height: 0.19rem;
}
.character .img {
    width: 0.2rem;
    height: 0.2rem;
}
.grow_up .img {
    width: 0.18rem;
    height: 0.17rem;
    position: absolute;
}
.img {
    position: absolute;
    top: 0.17rem;
    left: 50%;
    transform: translate(-50%,0);
}
.img img {
    width: 100%;
    height: 100%;
}
.yellow_text {
    width: 100%;
    text-align: center;
    position: absolute;
    top: 0.42rem;
    left: 50%;
    transform: translate(-50%,0);
    font-size: 0.11rem;
    font-family: 'Normal';
    color: #D07437;
}
.black_text {
     width: 100%;
    text-align: center;
    position: absolute;
    top: 0.6rem;
    left: 50%;
    transform: translate(-50%,0);
    font-size: 0.11rem;
    font-family: 'Normal';
    color: #101010;
}
/* 成长 */
.chengzhang_label {
    position: absolute;
    top: 1.88rem;
    left: 0.38rem;
    font-size: 0.1rem;
    font-family: 'Normal';
    color: #673202;
    font-weight: bold;
}
.chengzhang_bar {
    width: 2.52rem;
    height: 0.19rem;
    position: absolute;
    top: 2.08rem;
    left: 50%;
    transform: translate(-50%,0);
    background: url('../assets/images/chengzhang_bar_bgc.png') no-repeat;
    background-size: 100% 100%;
}
.chengzhang_val_box {
    width: 98%;
    height: 73%;
    border-radius: 0.03rem;
    position: absolute;
    top: 50%;
    left: 0.025rem;
    transform: translate(0,-52%);
    /* background-color: #fff; */
}
.chengzhang_val {
    height: 100%;
    text-align: center;
    line-height: 1.5;
    font-size: 0.08rem;
    background-color: #5899DC;
    color: #fff;
    border-radius: 0.03rem;
}
/* 生命 */
.shengming_label {
    position: absolute;
    top: 2.32rem;
    left: 0.38rem;
    font-size: 0.1rem;
    font-family: 'Normal';
    font-weight: bold;
    color: #673202;
}
.shengming_bar {
    width: 1.13rem;
    height: 0.19rem;
    position: absolute;
    top: 2.52rem;
    left: 0.35rem;
    border-radius: 0.03rem;
    background: url('../assets/images/shengming_bar_bgc.png') no-repeat;
    background-size: 100% 100%;
}
.shengming_val_box {
    width: 95%;
    height: 70%;
    /* background-color: #fff; */
    border-radius: 0.03rem;
    position: absolute;
    top: 50%;
    left: 0.028rem;
    transform: translate(0,-51%);
}
.shengming_val {
    height: 100%;
    text-align: center;
    line-height: 1.5;
    font-size: 0.08rem;
    font-family: 'Normal';
    background-image: linear-gradient(#9BD271, #72B050);
    color: #fff;
    border-radius: 0.03rem;
}
/* 攻击 */
.gongji_label {
    position: absolute;
    top: 2.32rem;
    right: 1.07rem;
    font-size: 0.1rem;
    font-family: 'Normal';
    font-weight: bold;
    color: #673202;
}
.gongji_bar {
    width: 1.13rem;
    height: 0.19rem;
    position: absolute;
    top: 2.52rem;
    right: 0.37rem;
    border-radius: 0.03rem;
    background: url('../assets/images/shengming_bar_bgc.png') no-repeat;
    background-size: 100% 100%;
}
.gongji_val_box {
    width: 95%;
    height: 70%;
    /* background-color: #fff; */
    border-radius: 0.03rem;
    position: absolute;
    top: 50%;
    left: 0.028rem;
    transform: translate(0,-51%);
}
.gongji_val {
    height: 100%;
    text-align: center;
    line-height: 1.5;
    font-size: 0.08rem;
    font-family: 'Normal';
    background-image: linear-gradient(#9BD271, #72B050);
    color: #fff;
    border-radius: 0.03rem;
}
/* 防御 */
.fangyu_label {
    position: absolute;
    top: 2.75rem;
    left: 0.38rem;
    font-size: 0.1rem;
    font-family: 'Normal';
    font-weight: bold;
    color: #673202;
}
.fangyu_bar {
    width: 1.13rem;
    height: 0.19rem;
    position: absolute;
    top: 2.95rem;
    left: 0.35rem;
    border-radius: 0.03rem;
    background: url('../assets/images/shengming_bar_bgc.png') no-repeat;
    background-size: 100% 100%;
}
.fangyu_val_box {
    width: 95%;
    height: 70%;
    /* background-color: #fff; */
    border-radius: 0.03rem;
    position: absolute;
    top: 50%;
    left: 0.028rem;
    transform: translate(0,-51%);
}
.fangyu_val {
    height: 100%;
    text-align: center;
    line-height: 1.5;
    font-size: 0.08rem;
    font-family: 'Normal';
    background-image: linear-gradient(#9BD271, #72B050);
    color: #fff;
    border-radius: 0.03rem;
}
/* 速度 */
.sudu_label {
    position: absolute;
    top: 2.75rem;
    right: 1.07rem;
    font-size: 0.1rem;
    font-family: 'Normal';
    font-weight: bold;
    color: #673202;
}
.sudu_bar {
    width: 1.13rem;
    height: 0.19rem;
    position: absolute;
    top: 2.95rem;
    right: 0.37rem;
    border-radius: 0.03rem;
    background: url('../assets/images/shengming_bar_bgc.png') no-repeat;
    background-size: 100% 100%;
}
.sudu_val_box {
    width: 95%;
    height: 70%;
    /* background-color: #fff; */
    border-radius: 0.03rem;
    position: absolute;
    top: 50%;
    left: 0.028rem;
    transform: translate(0,-51%);
}
.sudu_val {
    height: 100%;
    text-align: center;
    line-height: 1.5;
    font-size: 0.08rem;
    font-family: 'Normal';
    background-image: linear-gradient(#9BD271, #72B050);
    color: #fff;
    border-radius: 0.03rem;
}
.upgrade {
    width: 1.02rem;
    height: 0.39rem;
    position: absolute;
    bottom: -0.07rem;
    left: 50%;
    transform: translate(-50%,0);
    cursor: pointer;
}
.set_pet_btn {
    width: 0.86rem;
    height: 0.32rem;
    position: absolute;
    bottom: 0;
    left: 26%;
    transform: translate(-50%,0);
    cursor: pointer;
}
.chat {
    width: 2.5rem;
    height: 0.86rem;
    background: url('../assets/images/chat_bgc.png');
    background-size: 100% 100%;
    margin-top: -0.1rem;
    box-sizing: border-box;
    padding: 0.18rem 0.25rem 0.18rem 0.34rem;
}
.chat .title {
    width: 100%;
    height: 0.6rem;
    font-size: 0.13rem;
    font-family: 'Medium';
    font-weight: bold;
    color: #482201;
    text-align: center;
    overflow: hidden;
    overflow-y: auto;
}
.chat_content {
    height: 0.29rem;
    font-size: 0.11rem;
    font-family: 'Normal';
    color: #482201;
    overflow: hidden;
    overflow-y: auto;
    cursor: n-resize;
}
.growth_stage {
    width: 0.17rem;
    height: 2rem;
    position: absolute;
    top: 0.8rem;
    left: 2.7rem;
}
.gray {
    width: 100%;
    height: 0.46rem;
    background: url('../assets/images/gray.png') no-repeat;
    background-size: 100% 100%;
    font-size: 0.08rem;
    font-family: 'Normal';
    font-weight: bold;
    color: #FFFFFF;
    text-align: center;
    box-sizing: border-box;
    padding: 0.13rem 0.01rem 0.13rem 0;
    margin-bottom: 0.15rem;
    cursor: pointer;
    position: relative;

}
.gray span {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%,-50%);
}
.purple  span {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%,-50%);
}
.purple {
    width: 100%;
    height: 0.46rem;
    background: url('../assets/images/purple.png') no-repeat;
    background-size: 100% 100%;
    font-size: 0.08rem;
    font-family: 'Normal';
    font-weight: bold;
    color: #FFFFFF;
    text-align: center;
    box-sizing: border-box;
    padding: 0.13rem 0.01rem 0.13rem 0;
    margin-bottom: 0.15rem;
    cursor: pointer;
    position: relative;
}
.motion {
    width: 0.86rem;
    height: 0.32rem;
    position: absolute;
    bottom: 0;
    left: 46%;
    cursor: pointer;
}
.motion2 {
    width: 0.86rem;
    height: 0.32rem;
    position: absolute;
    bottom: 0;
    left: 50%;
    transform: translate(-95%,0);
    cursor: pointer;  
}
.span_value {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%,-50%);
    color: #fff;
    font-size: 0.1rem;
    font-family: 'Normal';
}
::-webkit-scrollbar {
    width: 0.04rem !important;
}
::-webkit-scrollbar-thumb {
    height: 0.1rem !important;
}
</style>